import { PageHero } from "../components/site/PageHero";
import { FadeUp } from "../components/site/Motion";
import { CtaBand } from "../components/site/CtaBand";
import { AREA_IMG } from "../data/content";
import { useLang } from "../i18n/LangContext";

const Area = ({ a, i }) => (
  <article data-testid={`area-${a.id}`} className="grid gap-8 border-t border-[#D6CEBF] py-14 lg:grid-cols-12 lg:items-center lg:py-20">
    <FadeUp className={`lg:col-span-6 ${i % 2 ? "lg:order-2 lg:col-start-7" : ""}`}>
      <div className="group relative aspect-[4/3] overflow-hidden rounded-sm bg-[#EFEAE1]">
        <img src={AREA_IMG[a.id]} alt={a.title} className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105" />
      </div>
    </FadeUp>
    <FadeUp delay={0.1} className={`lg:col-span-5 ${i % 2 ? "lg:order-1" : "lg:col-start-8"}`}>
      <span className="font-mono text-sm text-[#C85A32]">0{i + 1} / 04</span>
      <h2 className="mt-4 font-serif text-4xl leading-tight tracking-tight text-[#1C1917] sm:text-5xl">{a.title}</h2>
      <p className="mt-5 text-base leading-relaxed text-stone-600 sm:text-lg">{a.text}</p>
    </FadeUp>
  </article>
);

export default function CosaFacciamo() {
  const { t } = useLang();
  const c = t.cosa;
  return (
    <main data-testid="cosa-facciamo-page">
      <PageHero
        key={c.lines[0]}
        testId="cosa-facciamo-hero"
        eyebrow={c.eyebrow}
        lines={c.lines}
        intro={c.intro}
      />
      <section className="mx-auto max-w-7xl px-5 sm:px-8">
        {t.areas.map((a, i) => <Area key={a.id} a={a} i={i} />)}
      </section>
      <CtaBand title={c.cta.title} to="/progetti" label={c.cta.label} testId="cosa-facciamo-cta" />
    </main>
  );
}
